import { StatementFormatter } from './Formatters/StatementFormatter';
export class Statement {
    constructor() {
        this.AccountId = null;
        this.InstrumentStr = null;
        this.Date = null;
        this.OperationTypeId = null;
        this.OperationType = null;
        this.OperationID = null;
        this.Amount = null;
        this.OpenPrice = null;
        this.ClosePrice = null;
        this.Quantity = null;
        this.TradeOpeningDate = null;
        this.OpenCrossPrise = null;
        this.PositionID = null;
        this.TradeId = null;
        this.Details = null;
        this._currency = null;
    }
    get Currency() {
        return this.getCurrency();
    }
    set Currency(value) {
        this._currency = value;
    }
    get Account() {
        return StatementFormatter.Account(this);
    }
    set Account(account) {
        var _a;
        this.AccountId = (_a = account === null || account === void 0 ? void 0 : account.ID) !== null && _a !== void 0 ? _a : null;
    }
    // #region IStatement implementation
    getAccountId() {
        return this.AccountId;
    }
    getAccount() {
        return StatementFormatter.Account(this);
    }
    getSymbol() {
        return this.InstrumentStr;
    }
    getCurrency() {
        var _a, _b;
        if (isValidString(this._currency)) {
            return this._currency;
        }
        return (_b = (_a = this.Account) === null || _a === void 0 ? void 0 : _a.BaseCurrency) !== null && _b !== void 0 ? _b : null;
    }
    getDate() {
        return this.Date;
    }
    getPosOpeningDate() {
        return this.TradeOpeningDate;
    }
    getOperationType() {
        return this.OperationType;
    }
    getOperationTypeId() {
        return this.OperationTypeId;
    }
    getOperationId() {
        return this.OperationID;
    }
    getAmount() {
        return this.Amount;
    }
    getOpenPrice() {
        return this.OpenPrice;
    }
    getClosePrice() {
        return this.ClosePrice;
    }
    getQuantity() {
        return this.Quantity;
    }
    getDetails() {
        return this.Details;
    }
    getPositionId() {
        return this.PositionID;
    }
    getTradeId() {
        return this.TradeId;
    }
    //#endregion IStatement implementation
    Dispose() {
        this.AccountId = null;
        this.InstrumentStr = null;
        this._currency = null;
    }
}
